export function isMediaQuery(minWidth) {
  return window.matchMedia(`(min-width: ${minWidth}px)`).matches;
}

export function is375Query() {
  return isMediaQuery(375);
}

export function is640Query() {
  return isMediaQuery(640);
}

export function is768Query() {
  return isMediaQuery(768);
}

export function is960Query() {
  return isMediaQuery(960);

}export function is1024Query() {
  return isMediaQuery(1024);
}

export function is1280Query() {
  return isMediaQuery(1200);
}

export function is1800Query() {
  return isMediaQuery(1800);
}

